<div class="saved-flts-container">
  <div *ngIf="savedFlights$ | async as savedFlights">
    <div *ngFor="let group of savedFlights.groups">
      <div class="date-header">{{ formatDate(group.date) }}</div>
      <div *ngFor="let flight of group.flights" class="flight-list-row">
        <div *ngIf="flight.leg$ | async as leg" class="flex-grow-1">
          <div mat-ripple class="flight-list box-shadow pointer thin-blue-border" (click)="onFlightClick(flight)">
            <app-leg-summary [leg]="leg.response" [isLoading]="leg.isLoading" [minimalView]="true"></app-leg-summary>
          </div>
        </div>
        <div class="trash-container warn-color">
          <mat-icon mat-ripple fontSet="material-icons-outlined" class="delete-icon"
            (click)="onDeleteClick(flight.id)">delete</mat-icon>
        </div>
      </div>
    </div>
  </div>
</div>